import React, {useEffect, useState} from 'react';
import {FiTrash2} from 'react-icons/fi';
import {BiReset} from "react-icons/bi";
import {Button, Toggle} from '../../../../components';
import {useViewerStore} from "../../../../store/store";
import {logger} from '../../../../services/loggingService';
import { CustomImageProperty, ImageryOptions } from '../../../../@types/enums';
import {
    centerMapPosition,
    ChangeMapMesh,
    fetchCustomMap,
    FetchMapImage,
    SetMapCustomSize,
    setImagery
} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/MapControl";
import SliderInput from "../../../../components/Pure-UI-Components/SliderInput/SliderInput";
import {clickButtonWithRef, registerRef} from "../../../../helpers/storeHelpers";

const CustomImageryProps = () => {
    const { sceneViewer, imageryType, customImagery} = useViewerStore();

    const [isDragImagery, setIsDragImagery] = useState(false);
    const [reset, setReset] = useState(false);

    const customImageScale = useViewerStore(state => state.customImageScale);
    const customImageRotation = useViewerStore(state => state.customImageRotation);


    useEffect(() => {
        if (imageryType === ImageryOptions.CUSTOM ) {
            if (customImagery){
                const img = new Image();
                img.src = customImagery;
                img.onload = () => {
                    setImagery(sceneViewer, img);
                    SetMapCustomSize(sceneViewer, CustomImageProperty.scale, customImageScale);
                    SetMapCustomSize(sceneViewer, CustomImageProperty.rotation, customImageRotation);
                };
            } else {
                fetchCustomMap(sceneViewer);
            }
        } else {
            FetchMapImage(sceneViewer, imageryType);
        }
    }, [imageryType, customImagery])

    const fileUploadHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) {
            logger.error('No file selected');
            return;
        }
        useViewerStore.setState({customImageFile : file})
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            if (typeof reader.result === "string") ChangeMapMesh(sceneViewer, reader.result, true);
            else logger.error("Unexpected FileReader result type");
        };
    }

    const CustomImageHandler = () => {
        clickButtonWithRef("customImgInput");
    }

    const deleteCustomImage = () => {
        useViewerStore.setState({customImagery : null})
        useViewerStore.setState({imageryType: ImageryOptions.DEFAULT});
    }

    const toggleDragImageryHandler = () => {
        setIsDragImagery(!isDragImagery);
        sceneViewer.setMoveMode(!isDragImagery);
    }

    const resetHadnler = () => {
        setReset(!reset);
        useViewerStore.setState({customImageScale: 1, customImageRotation: 0});
        sceneViewer.updateCustomImageProperty('scale', 1);
        sceneViewer.updateCustomImageProperty('rotation', 0);
        centerMapPosition(sceneViewer);
    }

    const onChangeScale = (value: number) => {
        useViewerStore.setState({customImageScale : value});
        sceneViewer.updateCustomImageProperty('scale', value);
    }

    const onChangeRotation = (value: number) => {
        const intValue = Math.round(value);
        useViewerStore.setState({customImageRotation : intValue});
        sceneViewer.updateCustomImageProperty('rotation', intValue);
    }

    return (
        <div className='tab__inner'>
            {imageryType === ImageryOptions.CUSTOM &&
                <>
                    <div className='tab__title'>
                        <span className='tab__title--text'>Custom Imagery</span>
                        <div className='tab__title--btns'>
                            {customImagery &&
                                <Button onClick={deleteCustomImage} variant='btn-clear' size='btn-resize'>
                                    <FiTrash2/>
                                </Button>
                            }
                        </div>
                    </div>

                    <div className='tab__column'>
                        <input 
                            accept={".png,.jpg"} 
                            onChange={fileUploadHandler} 
                            ref={registerRef("customImgInput")}
                            onClick={(e: any) => e.target.value = null} 
                            hidden type={"file"}
                        />
                        <Button className={`active`} variant='btn-primary-outline' size='btn-md'
                                onClick={CustomImageHandler}>Upload
                            Image</Button>
                    </div>
                </>
            }

            {(imageryType != ImageryOptions.CUSTOM || customImagery) &&
                <>
                    <div className="tab__title">
                        <span className="tab__title--text">Map transformations</span>
                        <div className="tab__title--btns">
                            <Button
                                onClick={resetHadnler}
                                variant='btn-clear'
                                size='btn-resize'
                                title={'Reset to Default'}>
                                <BiReset/>
                            </Button>
                        </div>
                    </div>
                    <div className='tab__column'>

                        <label className="tab__column--subtitle">Rotation</label>
                        <SliderInput
                            settings={{min: 0, max: 359, step: 1}}
                            unit="degrees"
                            value={customImageRotation}
                            onChange={onChangeRotation}

                        />
                        <label className="tab__column--subtitle">Scale</label>
                        <SliderInput
                            settings={{min: 0.1, max: 5, step: 0.01}}
                            included={false}
                            value={customImageScale}
                            onChange={onChangeScale}

                        />
                    </div>
                    <br/>
                    <div className='tab__column'>
                        <div className='tab__flex justify-between'>
                            <span className='tab__column--subtitle mb-0'>Move Imagery Using Mouse :</span>
                            <Toggle
                                onChange={toggleDragImageryHandler}
                                on={isDragImagery}
                                property='DragCutomImage'/>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}

export default CustomImageryProps;
